import { render, staticRenderFns } from "./scroll-box.vue?vue&type=template&id=72634458&scoped=true"
import script from "./scroll-box.vue?vue&type=script&lang=js"
export * from "./scroll-box.vue?vue&type=script&lang=js"
import style0 from "./scroll-box.vue?vue&type=style&index=0&id=72634458&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72634458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72634458')) {
      api.createRecord('72634458', component.options)
    } else {
      api.reload('72634458', component.options)
    }
    module.hot.accept("./scroll-box.vue?vue&type=template&id=72634458&scoped=true", function () {
      api.rerender('72634458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-public/com-yd-table/components/table-footer/scroll-box.vue"
export default component.exports